import { LabeledComponentDefinition, SingleInputComponentDefinition } from "./Component";

export function setComponentWidths(definition: LabeledComponentDefinition & SingleInputComponentDefinition) {
    if (definition.labelKey == null || definition.labelKey.length === 0) {
        definition.labelWidth = 0;
    }

    if (definition.inputWidth == null) {
        definition.inputWidth = 16 - (definition.labelWidth || 0);
    }
    if (definition.width == null) {
        definition.width = 16;
    }
    definition.labelWidth = definition.labelWidth ?? 16;
}
